<template>
	<div>
		<v-container>
			<div v-if="navigationId != 0" :class="['text-h5', 'pa-4', 'text-center']">
				{{ $t('titles.editingNavigation') }}
			</div>
			<div v-else :class="['text-h5', 'pa-4', 'text-center']">
				{{ $t('titles.newNavigation') }}
			</div>
			<v-row>
				<v-col cols="12">
					<InputField
						:readonly="!inEditMode"
						v-model="teacherNavigation.company"
						:errorBorder="!teacherNavigationValidation.company"
						:label="'* ' + $t('fields.companyName')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<Dropdown
						:readonly="!inEditMode"
						v-model="teacherNavigation.rank_id"
						:ajax="true"
						:clearable="true"
						:data="'ranks'"
						:errorBorder="!teacherNavigationValidation.rank_id"
						:label="'* ' + $t('fields.rank')"
					></Dropdown>
				</v-col>
				<v-col cols="12">
					<InputField
						:readonly="!inEditMode"
						v-model="teacherNavigation.ship_type"
						:errorBorder="!teacherNavigationValidation.ship_type"
						:label="'* ' + $t('fields.shipType')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<DatePicker
						:readonly="!inEditMode"
						v-model="teacherNavigation.start_date"
						:maxDate="maxDate"
						:errorBorder="!teacherNavigationValidation.start_date"
						:date-label="'* ' + $t('fields.startDate')"
					></DatePicker>
				</v-col>
				<v-col cols="12">
					<DatePicker
						:readonly="!inEditMode"
						v-model="teacherNavigation.end_date"
						:maxDate="maxDate"
						:errorBorder="!teacherNavigationValidation.end_date"
						:date-label="'* ' + $t('fields.endDate')"
					></DatePicker>
				</v-col>
			</v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row class="text-center">
			<v-col cols="12">
				<v-btn class="ma-2" color="primary" variant="text" @click="saveClick"> {{ $t('buttons.save') }} </v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import TeacherNavigation from '../../../models/TeacherNavigation';
import InputField from '../../trinkets/InputField';
import DatePicker from '../../trinkets/DatePicker';
import Dropdown from '../../trinkets/Dropdown';

export default {
	name: 'Navigation',
	components: { InputField, Dropdown, DatePicker },
	props: {
		navigationId: [String, Number],
		inEditMode: Boolean,
	},
	emits: ['close', 'reloadData'],
	data() {
		return {
			teacherNavigationValidation: new TeacherNavigation({}, true),
			teacherNavigation: new TeacherNavigation({ id: 0, teacher_id: this.$route.params.id }),
			maxDate: new Date().toISOString(),
		};
	},
	computed: {},
	watch: {
		navigationId() {
			this.getNavigation();
		},
	},
	mounted() {
		this.getNavigation();
	},
	methods: {
		cancelClick() {
			this.$emit('close');
		},
		getNavigation() {
			var vm = this;
			if (this.navigationId != 0) {
				this.$APICall(
					'get',
					'teacher-navigation/' + this.navigationId,
					{},
					(data, success) => {
						if (success) {
							vm.teacherNavigation = data;
						}
					},
					false
				);
			} else {
				this.teacherNavigation = new TeacherNavigation({ id: 0, teacher_id: this.$route.params.id });
			}
		},
		saveClick() {
			let success = true;
			let errorMessages = '';

			if (this.teacherNavigation.company == null || this.teacherNavigation.company == '') {
				success = false;
				this.teacherNavigationValidation.company = false;
			} else {
				if (this.teacherNavigation.company.length > 50) {
					this.teacherNavigationValidation.company = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.companyName'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.teacherNavigationValidation.company = true;
				}
			}

			if (this.teacherNavigation.ship_type == null || this.teacherNavigation.ship_type == '') {
				success = false;
				this.teacherNavigationValidation.ship_type = false;
			} else {
				if (this.teacherNavigation.ship_type.length > 100) {
					this.teacherNavigationValidation.ship_type = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.shipType'))
							.replace('%length%', '100') + '<br />';
				} else {
					this.teacherNavigationValidation.ship_type = true;
				}
			}

			if (!this.teacherNavigation.rank_id) {
				success = false;
				this.teacherNavigationValidation.rank_id = false;
			} else {
				this.teacherNavigationValidation.rank_id = true;
			}

			if (!this.teacherNavigation.start_date) {
				success = false;
				this.teacherNavigationValidation.start_date = false;
			} else {
				this.teacherNavigationValidation.start_date = true;
			}

			if (!this.teacherNavigation.end_date) {
				success = false;
				this.teacherNavigationValidation.end_date = false;
			} else {
				this.teacherNavigationValidation.end_date = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.navigationId) {
					action = 'put';
					addition = '/' + vm.navigationId;
				}
				this.$APICall(action, 'teacher-navigations' + addition, this.teacherNavigation, (data, success) => {
					if (success) {
						if (vm.navigationId == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						this.teacherNavigation = new TeacherNavigation({ id: 0, teacher_id: this.$route.params.id });
						vm.$emit('reloadData');
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
					this.$emit('close');
				});
			}
		},
	},
};
</script>
